import React, { useState, useEffect, useRef } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import signinimage from '../asserts/img/logo.png';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { signin } from '../slice/userSlice';
import { useNavigate } from 'react-router-dom';

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const isFreshLogin = useRef(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, response, message } = useSelector(state => state.user);

    useEffect(() => {
        if (response && response?.data?.access_token) {
            const hasStoredToken = !!localStorage.getItem('userToken') || !!sessionStorage.getItem('userToken');
            if (isFreshLogin.current) {
                // Fresh successful login — save token and go to dashboard
                if (rememberMe) {
                    localStorage.setItem('userToken', response.data.access_token);
                } else {
                    sessionStorage.setItem('userToken', response.data.access_token);
                }
                if (username) {
                    localStorage.setItem('adminUsername', username);
                }
                isFreshLogin.current = false;
                navigate('/dashboard');
            } else if (hasStoredToken) {
                // Already logged in with a valid stored session
                navigate('/dashboard');
            }
            // else: stale persisted response with no active session -> stay on login page
        } else if (error) {
            toast.error(message || 'Login failed. Check your email and password.');
        }
    }, [response, error, navigate, message, dispatch, rememberMe]);

    const loginHandler = async (e) => {
        e.preventDefault();
        isFreshLogin.current = true;
        dispatch(signin({ username, password }));
        // store user name in local storage
        // store email in local storage
        localStorage.setItem('email',username)
    };

    const handleRememberMeChange = (e) => {
        setRememberMe(e.target.checked);
    };

    return (
        <section className="login-section" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#bad7f5', position: 'relative', overflow: 'hidden', padding: '1rem' }}>
            {/* Background elements */}
            <div style={{ position: 'absolute', top: '-10%', right: '-10%', width: '400px', height: '400px', background: 'rgba(14, 103, 177, 0.05)', filter: 'blur(100px)', borderRadius: '50%' }}></div>
            <div style={{ position: 'absolute', bottom: '-10%', left: '-10%', width: '300px', height: '300px', background: 'rgba(139, 92, 246, 0.05)', filter: 'blur(100px)', borderRadius: '50%' }}></div>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-4 col-lg-5 col-md-7 col-sm-10">
                        <div className="card shadow-md" style={{ border: '1px solid #e2e8f0', background: '#ffffff', borderRadius: '24px', padding: '1rem' }}>
                            <div className="card-body">
                                <div className="text-center mb-5">
                                    <img src={signinimage} alt='logo' style={{ width: '120px', marginBottom: '2rem' }} />
                                    <h1 className="h3 font-weight-bold text-dark mb-2" style={{ letterSpacing: '-0.02em' }}>Welcome Admin</h1>
                                </div>

                                <form className="user" onSubmit={loginHandler}>
                                    <div className="form-group mb-4">
                                        <label className="small text-muted font-weight-bold ml-1 mb-2" htmlFor="adminEmailInput">EMAIL ADDRESS</label>
                                        <input 
                                            id="adminEmailInput"
                                            type="email" 
                                            className="form-control"
                                            placeholder="Enter admin Email"  
                                            onChange={(e) => setUsername(e.target.value)}
                                            style={{ height: '48px', borderRadius: '12px' }}
                                        />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label className="small text-muted font-weight-bold ml-1 mb-2" htmlFor="adminPasswordInput">PASSWORD</label>
                                        <div style={{ position: 'relative' }}>
                                            <input 
                                                id="adminPasswordInput"
                                                type={showPassword ? "text" : "password"} 
                                                className="form-control"
                                                placeholder="••••••••" 
                                                onChange={(e) => setPassword(e.target.value)}
                                                autoComplete="current-password"
                                                style={{ height: '48px', borderRadius: '12px', paddingRight: '45px' }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setShowPassword(!showPassword)}
                                                style={{
                                                    position: 'absolute',
                                                    right: '15px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#94a3b8',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '0',
                                                    zIndex: 10
                                                }}
                                            >
                                                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div className="d-flex align-items-center justify-content-between mb-4 px-1">
                                        <div className="custom-control custom-checkbox small">
                                            <input 
                                                type="checkbox" 
                                                className="custom-control-input" 
                                                id="customCheck" 
                                                checked={rememberMe}
                                                onChange={handleRememberMeChange}
                                            />
                                            <label className="custom-control-label text-muted" htmlFor="customCheck">Remember me</label>
                                        </div>
                                    </div>

                                    <button 
                                        type="submit"
                                        disabled={loading} 
                                        className="btn btn-primary w-100" 
                                        style={{ height: '48px', fontSize: '0.95rem', borderRadius: '12px' }}
                                    >
                                        {loading ? 'Signing in...' : 'Sign In'}
                                    </button>
                                </form>

                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Login;
